import parseHTML from '../../../utilities/parseHTML';
import sanitize from '../../../utilities/parseHTML/purify';

const categoryCardsPropsTransformer = (props) =>
{
    const { title, categories } = props;
    const mappedCategories = categories?.map(({category}) => ({ ...category }));

    return {
        title: title ? parseHTML(title, ['learningCenter']).parsed : '',
        cards: mappedCategories.map(category => ({
            id: sanitize(category.databaseId || ''),
            title: parseHTML(category.name || '', ['learningCenter']).parsed, 
            description: parseHTML(category.description || '', ['learningCenter']).parsed, 
            url: sanitize(category.uri || '')
        }))
    }
}

export default categoryCardsPropsTransformer;
